The details of the advertisement product for a job ad.
